import * as React from 'react'

import {
    Stack,
    List,
    ListItemButton,
    ListItemIcon,
    ListSubheader,
    Box,
    Avatar,
    ListItem,
    useMediaQuery,
    Container,
    Paper
} from '@mui/material'
import { Logout } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

import { CopyRight, PrincipalDiv } from './styles';
import { InformationFooter } from './Information';

interface INavBar {

}



const Footer: React.FC<INavBar> = () => {
    const navigate = useNavigate();
    const matches = useMediaQuery('(max-width:800px)');
    return (
        <PrincipalDiv>
            <InformationFooter />
            <CopyRight>
                <p>Copyright 2022 © All rights Reserved. <strong>SetraBH</strong></p>
            </CopyRight>
        </PrincipalDiv>

    );
}

export { Footer }